import {
  GpsOnly,
  VideoSection,
  Workout,
  Coaching,
} from '@kinomap-dev/ng-ui-lib';
import { Playlist } from '@kinomap-dev/ng-ui-lib/lib/models/playlist.model';

export class FavoriteState {
  videos: VideoSection[] = [];
  isLoadingVideos: boolean = false;
  areVideosComplete: boolean = false;

  gpsTracks: GpsOnly[] = [];
  isLoadingGpsTracks: boolean = false;
  areGpsTracksComplete: boolean = false;

  workouts: Workout[] = [];
  isLoadingWorkouts: boolean = false;
  areWorkoutsComplete: boolean = false;

  coachings: Coaching[] = [];
  isLoadingCoachings: boolean = false;
  areCoachingsComplete: boolean = false;

  playlists: Playlist[] = [];
  isLoadingPlaylists: boolean = false;
  arePlaylistsComplete: boolean = false;
}
